/** The Home tile's anchor, and the query parameter the budget page reads to
 *  offer a way back to it. Shared so the two ends cannot drift apart. */
export const MARKETING_TILE_ANCHOR = "marketing-source-performance"
export const BUDGET_RETURN_PARAM = "from"
